/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { featureKey } from './avi-data-grid-store.selectors';
import { aviDataGridStoreReducer } from './avi-data-grid-store.reducer';

@NgModule({
    imports: [
        StoreModule.forFeature(featureKey, aviDataGridStoreReducer),
    ],
})
export class AviDataGridStoreModule {}
